import Context from './Context';

type Props = { namespace: string; children: React.ReactNode };

const Provider = ({ children, namespace }: Props) => <Context.Provider value={namespace}>{children}</Context.Provider>;

export default Provider;
